import { InfoOutlined } from '@mui/icons-material';
import { Box, IconButton, Popover } from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';

import { PositionConversionHistory } from '@work4all/models/lib/Classes/PositionConversionHistory.entity';

import { PositionInfoDialog } from './PositionInfoDialog';

interface PositionInfoCellProps {
  value: PositionConversionHistory[];
}

export const PositionInfoCell = (props: PositionInfoCellProps) => {
  const { value } = props;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();

  if (!value?.length) {
    return null;
  }

  return (
    <>
      <Tooltip title={t('COMMON.INFO')}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <IconButton
            size="small"
            style={{ padding: 0 }}
            onClick={() => setPopoverOpen(true)}
            ref={buttonRef}
          >
            <InfoOutlined color="primary" />
          </IconButton>
        </Box>
      </Tooltip>
      {popoverOpen && (
        <Popover
          open={popoverOpen}
          onClose={() => setPopoverOpen(false)}
          anchorEl={buttonRef.current}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <PositionInfoDialog positionConversionHistoryList={value} />
        </Popover>
      )}
    </>
  );
};
